export default "__VITE_ASSET__CeBxRrCZ__"